// extracted by mini-css-extract-plugin
export var editButton = "_oj-0";